<template>
    <div class="other_offers">
        <div class="other_offers__inner container">
            <div class="other_offers__ttl_wrapper flex j_sb wc-lg">
                <h2 class="f-24 bold uppercase">{{ $fn.tr('Other Offers') }}</h2>
                <div class="other__ofers__navigation flex a_center">
                           <div class="other_offers__prev pointer">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                                <g id="Group_2500" data-name="Group 2500" transform="translate(0 0)">
                                    <g id="Group_5_Copy_3" data-name="Group 5 Copy 3">
                                    <path id="Combined_Shape_Copy_2" data-name="Combined Shape Copy 2" d="M6.175.342a1.167,1.167,0,0,0,0,1.65l3.842,3.842H1.166a1.167,1.167,0,0,0,0,2.334h8.849L6.175,12.008a1.166,1.166,0,1,0,1.65,1.65l5.834-5.833.02-.021.01-.01.01-.01.012-.013.007-.008.013-.015.005-.006.014-.017,0-.005.014-.018,0,0,.013-.018,0,0,.013-.018,0-.006.012-.018,0-.007.01-.016.005-.009.008-.014.007-.012.006-.011.009-.016,0-.007.011-.021v0a1.166,1.166,0,0,0-.24-1.359L7.824.342a1.167,1.167,0,0,0-1.65,0Z" transform="translate(14 14) rotate(180)" fill="#613dd1"/>
                                    </g>
                                </g>
                                </svg>


                                

                    </div>

                    <div class="other_offers__next pointer">
                        
                                   <svg id="Group_2499" data-name="Group 2499" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                            <g id="Group_5_Copy_3" data-name="Group 5 Copy 3">
                                <path id="Combined_Shape_Copy_2" data-name="Combined Shape Copy 2" d="M6.175,13.658a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.849L6.175,1.992A1.166,1.166,0,0,1,7.824.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.824,13.658a1.167,1.167,0,0,1-1.65,0Z" fill="#613dd1"/>
                            </g>
                            </svg>



                       

                    </div>
             
                </div>
            </div>

                        <swiper :options="swiperOptions">
  
                                <swiper-slide :key="index" v-for="(service, index) in content">
                                    <div class="other_offers__slide wc-lg">
                                                           <router-link :to="$store.getters['main/getSingleUrl'](service)" class="offers_list__box news_list__box  flex column">
                      <div class="offers_list__img_wrapper news_list__img_wrapper br-12">
                        <div class="offers_list__label flex j_center" v-if="_.get(service, 'company_image[0].url')">
                          <img :src="_.get(service, 'company_image[0].url')">
                        </div>
                        <div class="offers_list__img_overlay bg-overlay"></div>
                        <h4 class="f-55 bold f-white">{{ service.offer }}</h4>
                                            <img :src="service.cover_image[0].url" class="cover"
                      :alt="$route.name == 'PageViewRouter_ge' && service.seo_keywords_ge ? service.seo_keywords_ge : $route.name == 'PageViewRouter_en' && service.seo_keywords_en ? service.seo_keywords_en : ''">
                      </div>
    
                      <div class="offers_list__text-box news_list__text-box flex column">
                            <h2 class="f-18 bold uppercase">{{service.title}}</h2>
                      <h3 class="f-14 medium">{{service.teaser}}</h3>
                      <div class="f-16 bold uppercase f-light-purple flex a_center">
                        <svg id="Group_5_Copy_3" data-name="Group 5 Copy 3" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
  <path id="Combined_Shape_Copy_2" data-name="Combined Shape Copy 2" d="M6.175,13.659a1.167,1.167,0,0,1,0-1.65l3.842-3.842H1.166a1.167,1.167,0,0,1,0-2.334h8.85L6.175,1.992A1.167,1.167,0,0,1,7.825.342l5.834,5.833.02.021.01.01.01.01.012.013.007.008.013.015.005.006.014.017,0,.005.014.018,0,0,.013.018,0,0,.013.018,0,.006.012.018,0,.007.01.016.005.009.008.014.007.012.006.011.009.016,0,.007.011.021v0a1.166,1.166,0,0,1-.24,1.359L7.825,13.659a1.167,1.167,0,0,1-1.65,0Z" fill="#7063e9"/>
</svg>

                        {{ $fn.tr('Get Offer')}}
                        </div>
                      </div>
                  
                  

                    </router-link>
                                            
                                        

                                
                                    
                                
                                    </div>
                                
                                </swiper-slide>
                        </swiper>

        </div>
    </div>
</template>

<script>
export default {
        props: ['contentData'],
        data(){
            return{
                        swiperOptions: {
          slidesPerView: 2,
          spaceBetween: 30,
          grabCursor: true,
            //    slidesOffsetBefore: 405,
            // slidesOffsetAfter: 20,
            speed: 800,
            watchOverflow: true,
    
          navigation: {
          nextEl: '.other_offers__next',
          prevEl: '.other_offers__prev',
        },
        breakpoints: {

         
          767: {
            spaceBetween: 10,
            slidesPerView: 1,
            // slidesOffsetBefore: 20,
            // slidesOffsetAfter: 20,
          },    
        
        },
            on: {
            touchMove() {
                if ( document.querySelectorAll(".other_offers .swiper-slide").length >= 2) {
                    document
                        .querySelectorAll(".other_offers .swiper-slide")
                        .forEach((slide) => {
                            slide.style.transform = "scale(0.9, 0.9)";
                        });
                }
            },
            touchEnd() {
                if ( document.querySelectorAll(".other_offers .swiper-slide").length >= 2) {
                    document
                        .querySelectorAll(".other_offers .swiper-slide")
                        .forEach((slide) => {
                            slide.style.transform = "scale(1, 1)";
                        });
                }
            },
        },
        
    
        }
            }
        },

        computed: {
            content(){
                return  _.get(this.contentData, 'data.list').filter(cont => cont.id !==  _.get(this.$store.state.main.current_content, 'primary.data.list[0].id'));
            }
        }

}
</script>

<style lang="sass" scoped>
.other_offers
    padding-top: 55px
    padding-bottom: 89px
    .swiper-slide   
        transition: all 1.1s cubic-bezier(0.165, 0.84, 0.44, 1)

    &__inner

    &__slide
        h4
            position: absolute
            bottom: 17px
            left: 0
            text-align: center
            z-index: 3
            width: 100%
    &__ttl_wrapper
        margin-bottom: 34px
        color: #575757
    &__prev
        margin-right: 32px
    &__prev, &__next
        transition: .4s
        &.swiper-button-disabled
            opacity: 0.4
        svg path
            transition: .4s
        &:hover
            svg path
                fill: #28136D
    @media (max-width: 767px)
        padding-bottom: 34px
</style>